(function () {
    window.WatchlistApp = window.WatchlistApp || {};

    const Table = {
        buildTableRow: function (stock, index, isEditMode, holdings) {
            if (!stock) return '';

            const Utils = window.WatchlistApp.Utils;
            const ticker = stock.ticker || 'N/A';
            const price = Utils.getStockProperty(stock, 'price');

            const holding = holdings ? holdings[ticker] : null;
            let quantity = holding ? (parseFloat(holding.quantity) || 0) : 0;
            if (quantity === 0 && stock.quantity) {
                quantity = parseFloat(stock.quantity) || 0;
            }
            
            
            const hPrice = (holding && holding.price !== null && holding.price !== undefined) ? parseFloat(holding.price) : 0;
            
            const totalCostBasis = hPrice; 

            const dailyChangePerc = Utils.getStockProperty(stock, 'todaysChangePerc');
            const dailyChangeVal = Utils.getStockProperty(stock, 'todaysChange');

            const totalChangePerc = Utils.getStockProperty(stock, 'totalChangePercent');


            const dailyIsPositive = dailyChangePerc >= 0;
            const dailyColor = dailyIsPositive ? 'positive' : 'negative';
            const dailySign = dailyIsPositive ? '+' : '-';

            const totalIsPositive = totalChangePerc >= 0;

            let valueChangeCell = '<td></td>';
            let totalValueChangeCell = '<td></td>';
            let totalGainLossPercCell = '<td></td>';

            if (quantity > 0) {
                const valueChange = dailyChangeVal * quantity;
                const valueChangePositive = valueChange >= 0;
                const valueChangeColor = valueChangePositive ? 'positive' : 'negative';
                const valueChangeSign = valueChangePositive ? '+' : '-';
                valueChangeCell = `<td class="${valueChangeColor}">${valueChangeSign}$${Math.abs(Math.round(valueChange)).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>`;
            }

            if (quantity > 0 && totalCostBasis > 0) {
                const currentPriceVal = parseFloat(price) || 0;
                
                const totalCurrentValue = currentPriceVal * quantity;
                
                const totalValueChange = totalCurrentValue - totalCostBasis;
                const totalValueChangePositive = totalValueChange >= 0;
                const totalValueChangeColor = totalValueChangePositive ? 'positive' : 'negative';
                const totalValueChangeSign = totalValueChangePositive ? '+' : '-';
                totalValueChangeCell = `<td class="${totalValueChangeColor}">${totalValueChangeSign}$${Math.abs(Math.round(totalValueChange)).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>`;
                
                let totalGainLossPerc = 0;
                if (totalCostBasis !== 0) {
                     totalGainLossPerc = ((totalCurrentValue - totalCostBasis) / totalCostBasis) * 100;
                }
                const totalGainLossPositive = totalGainLossPerc >= 0;
                const totalGainLossColor = totalGainLossPositive ? 'positive' : 'negative';
                const totalGainLossSign = totalGainLossPositive ? '+' : '-';
                totalGainLossPercCell = `<td class="${totalGainLossColor}">${totalGainLossSign}${Math.abs(totalGainLossPerc).toFixed(1)}%</td>`;
            }

            return `
                <tr data-stock-index="${index}">
                    ${isEditMode ? '<td class="checkbox-cell"><input type="checkbox" class="row-checkbox"></td>' : ''}
                    <td class="symbol-cell">${ticker}</td>
                    ${isEditMode ?
                    `
                    <td class="editable-cell" data-field="quantity" data-raw-value="${(holding && holding.quantity !== undefined && holding.quantity !== null) ? holding.quantity : 0}">
                        ${(holding && parseFloat(holding.quantity)) ? holding.quantity : ''}
                    </td>
                    <td class="editable-cell" data-field="price" data-raw-value="${(holding && holding.price !== undefined && holding.price !== null) ? holding.price : 0}">
                        ${(holding && parseFloat(holding.price)) ? '$' + parseFloat(holding.price).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ''}
                    </td>
                    `
                    :
                    `<td>$${(parseFloat(price) || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                        <td class="${dailyColor}">${dailySign}${Math.abs(dailyChangePerc).toFixed(1)}%</td>
                        <td class="${dailyColor}">${dailySign}$${Math.abs(dailyChangeVal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                        ${valueChangeCell}
                        ${totalGainLossPercCell}
                        ${totalValueChangeCell}`
                }
                </tr>
            `;
        },

        setupTableEventHandlers: function (container, stockData, isEditMode) {
            if (isEditMode) {
                const selectAll = container.querySelector('.select-all-checkbox');
                if (selectAll) {
                    selectAll.addEventListener('change', function () {
                        const checkboxes = container.querySelectorAll('.row-checkbox');
                        checkboxes.forEach(cb => cb.checked = this.checked);
                    });
                }

                const editableCells = container.querySelectorAll('.editable-cell');
                editableCells.forEach(cell => {
                    cell.addEventListener('click', function (e) {
                        if (this.querySelector('input')) return;

                        const field = this.getAttribute('data-field');
                        const rawValue = parseFloat(this.getAttribute('data-raw-value')) || 0;
                        const displayValue = rawValue === 0 && this.textContent.trim() === '' ? '' : rawValue;

                        const input = document.createElement('input');
                        input.type = 'number';
                        input.value = displayValue;
                        input.className = 'watchlist-table-input';

                        this.innerHTML = '';
                        this.appendChild(input);
                        input.focus();
                        const saveChange = async () => {
                            const newValue = parseFloat(input.value);
                            const finalValue = isNaN(newValue) ? 0 : newValue;

                            const row = this.closest('tr');
                            const stockIndex = parseInt(row.getAttribute('data-stock-index'));
                            const stock = stockData[stockIndex];

                            if (stock) {
                                const State = window.WatchlistApp.State;
                                const currentWatchlist = State.allWatchlists.find(w => w.id === State.currentWatchlistId);
                                const currentHolding = (currentWatchlist && currentWatchlist.holdings) ? currentWatchlist.holdings[stock.ticker] : {};

                                if (finalValue === rawValue) {
                                    window.WatchlistApp.Table.renderWatchlistTable(container, true);
                                    return;
                                }

                                const updatePayload = {
                                    ticker: stock.ticker,
                                    quantity: (field === 'quantity') ? finalValue : (currentHolding.quantity || 0),
                                    price: (field === 'price') ? finalValue : (currentHolding.price || 0),
                                };

                                try {
                                    if (currentWatchlist) {
                                        if (!currentWatchlist.holdings) currentWatchlist.holdings = {};
                                        if (!currentWatchlist.holdings[stock.ticker]) currentWatchlist.holdings[stock.ticker] = {};
                                        currentWatchlist.holdings[stock.ticker][field] = finalValue;
                                    }

                                    window.WatchlistApp.Table.renderWatchlistTable(container, true);

                                    if (isEditMode) {
                                         const event = new CustomEvent('watchlist-cell-edited', { 
                                             detail: { updatePayload },
                                             bubbles: true 
                                         });
                                         container.dispatchEvent(event);
                                    } else {
                                        if (window.WatchlistAPIManager && window.WatchlistAPIManager.instance) {
                                           await window.WatchlistAPIManager.instance.addTickersToWatchlist(State.currentWatchlistId, [updatePayload]);
                                        } else {
                                            console.warn('[Table] WatchlistAPIManager not found, changes local only.');
                                        }
                                    }
                                } catch (err) {
                                    console.error('[Table] Failed to save inline edit:', err);
                                }
                            } else {
                                window.WatchlistApp.Table.renderWatchlistTable(container, true);
                            }
                        };

                        input.addEventListener('blur', saveChange);
                        input.addEventListener('keydown', (e) => {
                            if (e.key === 'Enter') input.blur();
                        });
                        
                        e.stopPropagation();
                    });
                });
            }

            const symbolCells = container.querySelectorAll('.symbol-cell');
            symbolCells.forEach(cell => {
                cell.addEventListener('click', function () {
                    const row = this.closest('tr');
                    const stockIndex = parseInt(row.getAttribute('data-stock-index'));
                    const stock = stockData[stockIndex];

                    if (stock) {
                        const stockBars = document.querySelectorAll('[stock-bar]');
                        if (stockBars.length > 0 && stockBars[0].components && stockBars[0].components['stock-bar']) {
                            const stockBarComponent = stockBars[0].components['stock-bar'];
                            stockBarComponent.openStockChart(stock, false);

                            let exchange = stock.tickerDetails?.primary_exchange || stock.tickerSummary?.primary_exchange || 'Unknown Exchange';
                            if (exchange === "New York Stock Exchange") {
                                exchange = "NYSE";
                            }
                            const formattedTicker = `${exchange}:${stock.ticker || 'UNKNOWN'}`;

                            if (typeof addTickerNewsToLeftPanel === 'function') {
                                addTickerNewsToLeftPanel(formattedTicker);
                            }
                        }
                    }
                });
            });
        },

        renderWatchlistTable: function (container, isEditMode = false) {
            if (!container) return;

            const State = window.WatchlistApp.State;
            const Utils = window.WatchlistApp.Utils;

            const stockCube = document.getElementById('stock-3d-cube');
            let stockData = [];

            if (State.currentWatchlistData) {
                stockData = Utils.normalizeStockData(State.currentWatchlistData);
            } else if (stockCube?.components?.['stock-cube-visualizer']?.stockInfo) {
                stockData = Utils.normalizeStockData(stockCube.components['stock-cube-visualizer'].stockInfo);
            }

            const currentWatchlist = State.allWatchlists.find(w => w.id === State.currentWatchlistId);
            const holdings = currentWatchlist ? currentWatchlist.holdings : {};

            if (isEditMode) {
                stockData.sort((a, b) => (a.ticker || '').localeCompare(b.ticker || ''));
            } else {
                stockData = Utils.sortStockData(stockData, State.currentSortOption, State.currentSortOrder, holdings);
            }

            if (!stockData || stockData.length === 0) {
                if (!isEditMode) {
                    container.innerHTML = '<div class="watchlist-table-empty">No data available</div>';
                    return;
                }
            }



            const tableRows = stockData.map((stock, index) => this.buildTableRow(stock, index, isEditMode, holdings)).join('');

            const html = `
                <table class="watchlist-table">
                    <thead>
                        <tr>
                            ${isEditMode ?
                    `<th class="checkbox-cell"><input type="checkbox" class="select-all-checkbox"></th>
                                 <th>Symbol</th>
                                 <th># of Shares</th>
                                 <th>Cost Basis (Total cost for all shares)</th>`
                    :
                    `<th>Symbol</th>
                                 <th>Current Price</th>
                                 <th>Price Change %</th>
                                 <th>Price Change $</th>
                                 <th>Value Change</th>
                                 <th>Total % Price Change</th>
                                 <th>Total $ Value Change</th>`
                }
                        </tr>
                    </thead>
                    <tbody>
                        ${tableRows}
                    </tbody>
                </table>
            `;

            container.innerHTML = html;

            if (!isEditMode) {
                let existingButtonContainer = document.querySelector('.watchlist-table-actions');
                if (!existingButtonContainer) {
                    existingButtonContainer = document.createElement('div');
                    existingButtonContainer.className = 'watchlist-table-actions';
                    existingButtonContainer.innerHTML = '<button class="add-unit-btn">Add unit +</button>';
                    container.parentNode.insertBefore(existingButtonContainer, container.nextSibling);
                }
            }

            this.setupTableEventHandlers(container, stockData, isEditMode);
        }
    };

    window.WatchlistApp.Table = Table;
})();
